import { Link } from "@tanstack/react-router";
import { Badge, Card, Group, Stack, Text } from "@/components/ui";
import { MobileOnly } from "@/components/ui/ResponsiveTableList";
import { formatearMonto } from "@/shared/format/money";
import { formatFecha, formatFechaHora } from "@/shared/format/fecha";
import type { HistorialAutorizacionItem } from "../services/historial-service";
import { badgeEstadoActual } from "./estado-badge";

/**
 * Layout móvil · stack de cards. Visible solo < md (la tabla está
 * oculta en mobile). Cada card es clickable → detalle.
 */
export function HistorialMobileList({ items }: { items: HistorialAutorizacionItem[] }) {
  return (
    <MobileOnly className="flex flex-col gap-2">
      {items.map((it) => (
        <HistorialMobileCard key={`${it.solicitudId}-${it.nivelAutorizado}`} it={it} />
      ))}
    </MobileOnly>
  );
}

function HistorialMobileCard({ it }: { it: HistorialAutorizacionItem }) {
  const badge = badgeEstadoActual(it.estadoActualSolicitud, {
    nivelAutorizado: it.nivelAutorizado,
    cantidadNiveles: it.cantidadNiveles,
  });
  return (
    <Link to={`/solicitudes/${it.solicitudId}` as never} className="block no-underline">
      <Card padding="sm">
        <Stack gap={6}>
          <Group justify="space-between" wrap="nowrap">
            <Text size="sm" ff="mono" fw={600}>
              {it.folio}
            </Text>
            <Badge size="xs" color="exito">
              Nivel {it.nivelAutorizado}/{it.cantidadNiveles}
            </Badge>
          </Group>
          <Text size="xs" c="dimmed" truncate>
            {it.organizacionNombre ?? "—"} · {it.tipo ?? "—"}/{it.subtipo ?? "—"}
          </Text>
          <Group justify="space-between" wrap="nowrap">
            <Text size="xs" c="dimmed">
              {formatFechaHora(it.autorizadoAt)}
            </Text>
            <Text size="sm" fw={500}>
              {it.totalCfdi !== null
                ? formatearMonto(it.totalCfdi, it.monedaCfdi, { minimumFractionDigits: 2 })
                : "—"}
            </Text>
          </Group>
          <Group justify="space-between" wrap="nowrap">
            <Badge size="xs" color={badge.color}>
              {badge.label}
            </Badge>
            {it.fechaPago ? (
              <Text size="xs" c="dimmed">
                Pago: {formatFecha(it.fechaPago)}
              </Text>
            ) : null}
          </Group>
        </Stack>
      </Card>
    </Link>
  );
}
